import React from "react";

import { SVGIcon } from "../SVGIcon";
import { SVGIconComponent } from "../util";

import { SVGIconComponentV2, SVGIconPropsV2 } from "./types";

interface ICreateXPArgs {
  controlVar: `--slate-xp__control__${string}`;
  treatmentVar: `--slate-xp__treatment__${string}`;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ICreateXPIconArgs<T extends {} = {}> {
  control: SVGIconComponent<T>;
  treatment: SVGIconComponentV2<T>;
}

export const createIconExperiment = ({
  controlVar,
  treatmentVar,
}: ICreateXPArgs) => ({
  icon:
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    <T extends {} = {}>({
      control: ControlIcon,
      treatment: TreatmentIcon,
    }: ICreateXPIconArgs<T>) =>
      ((
        props: T &
          SVGIcon.IProps &
          SVGIconPropsV2 &
          React.RefAttributes<SVGElement>
      ) => (
        <>
          <ControlIcon
            {...props}
            style={{
              ...props.style,
              display: `var(${controlVar}, auto)`,
            }}
          />
          <TreatmentIcon
            {...props}
            style={{
              ...props.style,
              display: `var(${treatmentVar}, none)`,
            }}
          />
        </>
      )) as SVGIconComponent<T> | SVGIconComponentV2<T>,
  getStyle: (enabled: boolean | undefined): Record<string, string> => ({
    ...(enabled
      ? {
          [controlVar]: "none",
          [treatmentVar]: "auto",
        }
      : {}),
  }),
});
